export default __webpack_public_path__ + "static/media/healthfood.8416b4a6.jpg";